const defaultDevRegion = 'SG';

export function getCurEnv() {
  const hostname = window.location.hostname;
  if (hostname.includes('fe-fte')) return 'fte';
  if (hostname.includes('test')) return 'test';
  if (hostname.includes('uat')) return 'uat';
  if (hostname.includes('staging')) return 'staging';
  if (hostname.includes('localhost')) return 'test';
  if (hostname.includes('dev')) return 'test';

  const [projectName, _] = hostname.split('.');
  if (projectName === 'spx') return 'live';
  return 'test';
}

export const getEnvUrlPrefix = () => {
  const env = getCurEnv();
  return env === 'live' ? '' : `${env}.`;
};

export function getRegion(hostname: any): string {
  if (hostname.includes('spx')) {
    return hostname.substr(-2).toUpperCase();
  }
  if (hostname === 'localhost') {
    return process.env.ENV && JSON.stringify(process.env.ENV.toUpperCase()) || defaultDevRegion;
  }
  return 'UNKNOWN';
}

export function getCurRegion() {
  return getRegion(getHostname());
}

export function getHostname(): string {
  return window.location.hostname;
}

export function getOrigin(): string {
  return window.location.origin;
}
